module.exports = __webpack_public_path__ + "images/category_lp/tablet_smartwatch/main-view@2x_59579c42658a73f258749a131fbc61f3.png";